"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeCardStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeCardStyles = function makeCardStyles(_ref) {
  var _MuiCardTwoColumn;

  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  var cardActionButtonResetStyles = {
    padding: "unset",
    border: "unset",
    boxShadow: "unset"
  };
  return {
    MuiCard: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          '&[class*="MuiPaper-root"]': {
            backgroundColor: tokens.colors.background.color,
            color: tokens.colors["text-on-background"].color
          }
        }, tokens.card.card), {}, {
          "& .DhigCard--divider": {
            padding: "".concat(primitives.spacings["0"], " ").concat(primitives.spacings["6"]),
            margin: "".concat(primitives.spacings["6"], " ").concat(primitives.spacings["0"])
          },
          "&.MuiCard--quiet": _objectSpread(_objectSpread({}, tokens.card.quietCard), {}, {
            '& > [class*="MuiCardMedia-root"]': {
              borderRadius: primitives.borderRadii.large
            },
            '& > [class*="MuiCardContent-root"]': _objectSpread({}, tokens.card.quietCardContent),
            '& > [class*="MuiCardActions-root"]': _objectSpread({}, tokens.card.quietCardActions),
            "& .DhigCard--divider": {
              padding: primitives.spacings["0"]
            },
            "&.MuiCard--framed": _objectSpread(_objectSpread({}, tokens.card.quietAndFramedCard), {}, {
              '& > [class*="MuiCardMedia-root"]': _objectSpread(_objectSpread({}, tokens.card.quietAndFramedCardMedia), {}, {
                boxSizing: "border-box"
              }),
              '& > [class*="MuiCardContent-root"]': _objectSpread({}, tokens.card.quietAndFramedCardContent),
              '& > [class*="MuiCardActions-root"]': _objectSpread({}, tokens.card.quietAndFramedCardActions),
              "& .DhigCard--divider": {
                padding: "".concat(primitives.spacings["0"], " ").concat(primitives.spacings["2"])
              }
            })
          }),
          "&.MuiCard--framed": _objectSpread({}, tokens.card.framedCard),
          "&.MuiCard--twoColumns": (_MuiCardTwoColumn = {
            display: "flex"
          }, _defineProperty(_MuiCardTwoColumn, "& > div", {
            display: "flex",
            flexDirection: "column"
          }), _defineProperty(_MuiCardTwoColumn, '& > [class*="MuiCardMedia-root"]', {
            width: "auto"
          }), _MuiCardTwoColumn),
          "&.DhigCard--appearance--default, &.DhigCard--appearance--framed": {
            '&[class*="MuiPaper-rounded"]': {
              borderRadius: primitives.borderRadii.large
            }
          }
        })
      }
    },
    MuiCardActionArea: {
      styleOverrides: {
        root: {
          height: "fit-content",
          width: "fit-content",
          '&:hover [class*="MuiCard-root"]': _objectSpread({}, tokens.card.hover),
          '&:focus [class*="MuiCard-root"]': _objectSpread({}, tokens.card.focus),
          '&:active [class*="MuiCard-root"]': _objectSpread({}, tokens.card.pressed),
          '&:active:focus [class*="MuiCard-root"]': _objectSpread({}, tokens.card.pressed),
          "&.Mui-disabled": _objectSpread(_objectSpread({}, tokens.card.disabled), {}, {
            '& [class*="DhigCardActionButton"].Mui-disabled': {
              // ensure disabled opacities don't stack
              opacity: tokens.opacities.default.opacity
            }
          }),
          '&:focus [class*="DhigCardActionButton"] svg': {
            "& svg": {
              outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-focus"].rgb)
            },
            "&.DhigCardAction--icon--default": {
              display: "none"
            },
            "&.DhigCardAction--icon--solid": {
              display: "block"
            }
          },
          '&:focus:active [class*="DhigCardActionButton"] svg, &:active [class*="DhigCardActionButton"] svg': {
            "& svg": {
              outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-pressed"].rgb)
            },
            "&.DhigCardAction--icon--default": {
              display: "none"
            },
            "&.DhigCardAction--icon--solid": {
              display: "block"
            }
          },
          '&:hover [class*="DhigCardActionButton"] svg': {
            "&.DhigCardAction--icon--default": {
              display: "none"
            },
            "&.DhigCardAction--icon--solid": {
              display: "block"
            }
          }
        },
        focusHighlight: {
          display: "none"
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, tokens.card.cardActions), {}, {
          flexDirection: "column",
          alignItems: "flex-start",
          '& [class*="DhigCardActionButton"]': _objectSpread(_objectSpread({}, cardActionButtonResetStyles), {}, {
            svg: {
              marginRight: primitives.spacings[1],
              borderRadius: "50%",
              outlineOffset: "-1px"
            },
            "svg.DhigCardAction--icon--solid": {
              display: "none"
            },
            "svg.DhigCardAction--icon--default": {
              display: "block"
            },
            "&.Mui-disabled": _objectSpread(_objectSpread({}, cardActionButtonResetStyles), {}, {
              opacity: tokens.opacities.disabled.opacity
            }),
            "&:hover, :focus, :active, :focus:active": _objectSpread(_objectSpread({}, cardActionButtonResetStyles), {}, {
              backgroundColor: primitives.colors.detail.transparent,
              "svg.DhigCardAction--icon--default": {
                display: "none"
              },
              "svg.DhigCardAction--icon--solid": {
                display: "block"
              }
            }),
            "&:focus": {
              "& svg svg": {
                outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-focus"].rgb)
              }
            },
            "&:active, :focus:active": {
              "& svg svg": {
                outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-pressed"].rgb)
              }
            },
            span: {
              fontWeight: primitives.fontWeights.stout,
              color: tokens.colors["ink-on-background"].color
            },
            '&[class*="MuiButton-sizeMedium"]': tokens.typography["short-copy-medium"],
            '&[class*="MuiButton-sizeSmall"]': tokens.typography["short-copy-small"]
          })
        }),
        spacing: {
          "& > :not(:first-of-type)": {
            marginLeft: "".concat(primitives.spacings["0"], "px"),
            marginTop: primitives.spacings[2]
          }
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: _objectSpread({}, tokens.card.cardContent)
      }
    }
  };
};

exports.makeCardStyles = makeCardStyles;